import { useCanGoBack, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Breadcrumb, type BreadcrumbItem, useBreadcrumbNavigate } from './Breadcrumb';

type PageNavigationProps = {
  pathLink?: BreadcrumbItem[];
};

export function PageNavigation({ pathLink }: PageNavigationProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap empty:hidden">
      <BackButton pathLink={pathLink} />
      {pathLink && <Breadcrumb items={pathLink} />}
    </div>
  );
}

// A page opened in a fresh tab has no in-app history: the breadcrumb parent stands in for it.
function BackButton({ pathLink }: PageNavigationProps) {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const breadcrumbNavigate = useBreadcrumbNavigate();
  const parent = pathLink?.filter((item) => item.navigate !== undefined).at(-1)?.navigate;

  if (!canGoBack && !parent) return null;

  return (
    <button
      type="button"
      onClick={() => (parent && !canGoBack ? breadcrumbNavigate(parent) : router.history.back())}
      className="flex items-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-900 cursor-pointer"
    >
      <ArrowLeft className="size-3.5" />
      Retour
    </button>
  );
}
